"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerTypeQuery = exports.ContainerTypeUpdate = exports.ContainerTypeCreate = exports.ContainerTypeTransport = exports.DimensionsOutput = exports.DimensionsUpdate = exports.PortableToiletVariantLabels = exports.PortableToiletVariant = exports.PortableToiletVariants = exports.RearLoadVariantLabels = exports.RearLoadVariant = exports.RearLoadVariants = exports.FrontLoadVariantLabels = exports.FrontLoadVariant = exports.FrontLoadVariants = exports.TrailerAxleConfigurationLabels = exports.TrailerAxleConfiguration = exports.TrailerAxleConfigurations = exports.RollOffRailStyleLabels = exports.RollOffRailStyle = exports.RollOffRailStyles = exports.RollOffLiftTypeLabels = exports.RollOffLiftType = exports.RollOffLiftTypes = exports.RollOffVariantLabels = exports.RollOffVariant = exports.RollOffVariants = exports.ContainerTypeLabels = exports.ContainerType = exports.ContainerTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
exports.ContainerTypes = [
    'ROLL_OFF',
    'FRONT_LOAD',
    'REAR_LOAD',
    'TOTER',
    'TRAILER',
    'PORTABLE_TOILET',
    'OTHER',
];
exports.ContainerType = typebox_1.Type.Union(exports.ContainerTypes.map((type) => typebox_1.Type.Literal(type)));
exports.ContainerTypeLabels = {
    ROLL_OFF: 'Roll Off',
    FRONT_LOAD: 'Front Load',
    REAR_LOAD: 'Rear Load',
    TOTER: 'Toter',
    TRAILER: 'Trailer',
    PORTABLE_TOILET: 'Portable Toilet',
    OTHER: 'Other',
};
//  -------------- Roll Off Options --------------
exports.RollOffVariants = [
    'OPEN_TOP',
    'CLOSED_TOP',
    'COMPACTOR_STATIONARY',
    'COMPACTOR_SELF_CONTAINED',
    'DUMP_TRAILER',
    'HINGE_TOP',
    'ROLL_TOP',
];
exports.RollOffVariant = typebox_1.Type.Union(exports.RollOffVariants.map((m) => typebox_1.Type.Literal(m)));
exports.RollOffVariantLabels = {
    OPEN_TOP: 'Open Top',
    CLOSED_TOP: 'Closed Top',
    COMPACTOR_STATIONARY: 'Compactor Stationary',
    COMPACTOR_SELF_CONTAINED: 'Compactor Self Contained',
    DUMP_TRAILER: 'Dump Trailer',
    HINGE_TOP: 'Hinge Top',
    ROLL_TOP: 'Roll Top',
};
exports.RollOffLiftTypes = ['CABLE', 'HOOK', 'DEMPSTER', 'DUAL'];
exports.RollOffLiftType = typebox_1.Type.Union(exports.RollOffLiftTypes.map((m) => typebox_1.Type.Literal(m)));
exports.RollOffLiftTypeLabels = {
    CABLE: 'Cable',
    HOOK: 'Hook',
    DEMPSTER: 'Dempster',
    DUAL: 'Dual (Hook and Cable)',
};
exports.RollOffRailStyles = ['INSIDE', 'OUTSIDE', 'INSIDE_OUTSIDE'];
exports.RollOffRailStyle = typebox_1.Type.Union(exports.RollOffRailStyles.map((m) => typebox_1.Type.Literal(m)));
exports.RollOffRailStyleLabels = {
    INSIDE: 'Inside',
    OUTSIDE: 'Outside',
    INSIDE_OUTSIDE: 'Inside Outside',
};
// -------------- Trailer Options --------------
exports.TrailerAxleConfigurations = ['SINGLE_AXLE', 'TANDEM_AXLE', 'TRI_AXLE'];
exports.TrailerAxleConfiguration = typebox_1.Type.Union(exports.TrailerAxleConfigurations.map((m) => typebox_1.Type.Literal(m)));
exports.TrailerAxleConfigurationLabels = {
    SINGLE_AXLE: 'Single Axle',
    TANDEM_AXLE: 'Tandem Axle',
    TRI_AXLE: 'Tri-Axle',
};
//  -------------- Front Load Options --------------
exports.FrontLoadVariants = ['SLANT_TOP', 'FLAT_TOP', 'VERTI_PACK'];
exports.FrontLoadVariant = typebox_1.Type.Union(exports.FrontLoadVariants.map((m) => typebox_1.Type.Literal(m)));
exports.FrontLoadVariantLabels = {
    SLANT_TOP: 'Slant Top',
    FLAT_TOP: 'Flat Top',
    VERTI_PACK: 'Verti-Pack',
};
//  -------------- Front Rear Load Options --------------
exports.RearLoadVariants = ['STANDARD', 'COMPACTOR_RECEIVER_BOX'];
exports.RearLoadVariant = typebox_1.Type.Union(exports.RearLoadVariants.map((m) => typebox_1.Type.Literal(m)));
exports.RearLoadVariantLabels = {
    STANDARD: 'Standard',
    COMPACTOR_RECEIVER_BOX: 'Compactor Receiver Box',
};
//  -------------- Portable Toilet Options --------------
exports.PortableToiletVariants = [
    'STANDARD',
    'ADA',
    'HAND_WASHING',
    'GREEN_WATER_TANK',
    'GREY_WATER_TANK',
];
exports.PortableToiletVariant = typebox_1.Type.Union(exports.PortableToiletVariants.map((m) => typebox_1.Type.Literal(m)));
exports.PortableToiletVariantLabels = {
    STANDARD: 'Standard',
    ADA: 'ADA',
    HAND_WASHING: 'Hand Washing',
    GREEN_WATER_TANK: 'Green Water Tank',
    GREY_WATER_TANK: 'Grey Water Tank',
};
exports.DimensionsUpdate = typebox_1.Type.Object({
    height: typebox_1.Type.Integer({ minimum: 1 }),
    width: typebox_1.Type.Integer({ minimum: 1 }),
    depth: typebox_1.Type.Integer({ minimum: 1 }),
    dimensionUnit: common_1.DimensionUnit,
});
exports.DimensionsOutput = typebox_1.Type.Partial(exports.DimensionsUpdate);
exports.ContainerTypeTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Object({
        id: typebox_1.Type.String({ format: 'uuid' }),
        name: typebox_1.Type.Optional(typebox_1.Type.String()),
        capacity: typebox_1.Type.Union([typebox_1.Type.Number({ multipleOf: 0.25, minimum: 0, maximum: 5 }), typebox_1.Type.Integer({ minimum: 5 })]),
        capacityUnit: common_1.CapacityUnit,
        dimensions: exports.DimensionsOutput,
        canBeTaggedContainers: typebox_1.Type.Boolean(),
        canBeUntaggedContainers: typebox_1.Type.Boolean(),
        deleted: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
        metadata: common_1.MetaData,
    }),
    typebox_1.Type.Union([
        typebox_1.Type.Object({
            style: typebox_1.Type.Literal('ROLL_OFF'),
            rollOffVariant: exports.RollOffVariant,
            rollOffRailStyle: exports.RollOffRailStyle,
            rollOffLiftStyle: exports.RollOffLiftType,
        }),
        typebox_1.Type.Object({
            style: typebox_1.Type.Literal('TRAILER'),
            axleConfiguration: exports.TrailerAxleConfiguration,
        }),
        typebox_1.Type.Object({
            style: typebox_1.Type.Literal('FRONT_LOAD'),
            frontLoadVariant: exports.FrontLoadVariant,
        }),
        typebox_1.Type.Object({
            style: typebox_1.Type.Literal('REAR_LOAD'),
            rearLoadVariant: exports.RearLoadVariant,
        }),
        typebox_1.Type.Object({
            style: typebox_1.Type.Literal('TOTER'),
        }),
        typebox_1.Type.Object({
            style: typebox_1.Type.Literal('PORTABLE_TOILET'),
            portableToiletVariant: exports.PortableToiletVariant,
        }),
        typebox_1.Type.Object({
            style: typebox_1.Type.Literal('OTHER'),
        }),
    ]),
]);
exports.ContainerTypeCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ContainerTypeTransport, ['id', 'dimensions', 'metadata']),
    typebox_1.Type.Object({
        dimensions: typebox_1.Type.Optional(exports.DimensionsUpdate),
    }),
]);
exports.ContainerTypeUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ContainerTypeCreate, ['name', 'dimensions']),
    typebox_1.Type.Object({
        name: (0, common_1.Nullable)(typebox_1.Type.String()),
        dimensions: (0, common_1.Nullable)(exports.DimensionsUpdate),
    }),
]));
exports.ContainerTypeQuery = typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        style: typebox_1.Type.Optional(exports.ContainerType),
        containerTypeIDs: typebox_1.Type.Optional(typebox_1.Type.String()), // comma separated list of container type ids
        canBeTaggedContainers: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
        canBeUntaggedContainers: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    }),
]);
//# sourceMappingURL=container-type.js.map